class CollectionAccordion extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.toggleButton = this.querySelector('.collection__sidebar-accordion-toggle');
    this.sublinks = this.querySelector('.collection__sidebar-sublinks');

    if (!this.toggleButton || !this.sublinks) return;

    // Check if accordion should be open initially (has is-open class)
    if (this.classList.contains('is-open')) {
      this.isOpen = true;
      this.sublinks.style.display = 'block';
      this.sublinks.style.maxHeight = this.sublinks.scrollHeight + 'px';
      this.updateAriaAttributes();
    } else {
      this.sublinks.style.display = 'none';
      this.sublinks.style.maxHeight = '0';
    }

    // Add click handler to toggle button
    this.toggleButton.addEventListener('click', this.handleToggle.bind(this));

    // Prevent link clicks from toggling accordion
    const links = this.querySelectorAll('.collection__sidebar-sublink');
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        // Allow default link behavior
        e.stopPropagation();
      });
    });
  }

  handleToggle(event) {
    event.preventDefault();
    event.stopPropagation();

    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.classList.add('is-open');
    this.sublinks.style.display = 'block';
    this.updateAriaAttributes();

    // Trigger animation - set max-height after display is set
    requestAnimationFrame(() => {
      this.sublinks.style.maxHeight = this.sublinks.scrollHeight + 'px';
    });
  }

  close() {
    this.classList.remove('is-open');
    // Set max-height to current height first, then animate to 0
    this.sublinks.style.maxHeight = this.sublinks.scrollHeight + 'px';

    requestAnimationFrame(() => {
      this.sublinks.style.maxHeight = '0';
    });

    // Wait for animation to complete before hiding
    setTimeout(() => {
      if (!this.isOpen) {
        this.sublinks.style.display = 'none';
      }
    }, 300);

    this.updateAriaAttributes();
  }

  updateAriaAttributes() {
    if (this.toggleButton) {
      this.toggleButton.setAttribute('aria-expanded', this.isOpen);
    }
  }
}

customElements.define('collection-accordion', CollectionAccordion);

